import i18n from "@/plugins/vue-i18n";

const EmailConfirmed = () =>
  import(/* webpackChunkName: "auth" */ "@/views/auth/email-confirmed/EmailConfirmedPage.vue");

const emailConfirmed = [
  {
    path: "/auth/email-confirmed",
    name: "EmailConfirmed",
    component: EmailConfirmed,
    meta: {
      title: i18n.t("title.yourEmailIsNowConfirmed"),
    },
  },
];

export default emailConfirmed;
